module.exports = __webpack_public_path__ + "img/heat-meter-counter-lg.3eae362f.svg";